export default function getResource(label, vars = []) {
    const resources = {
        item: 'ARTICLE',
        items: 'articles',
        qty: 'QTÉ',
        basketSubtotal: 'Sous-total du panier',
        subTotal: 'Sous-total',
        continue: 'Continuer à magasiner',
        seeSamples: 'Voir les échantillons, récompenses et promotions dans le',
        basket: 'panier',
        standardTitle: 'Ajouté pour l’expédition',
        sddTitle: 'Ajouté pour la livraison le jour même',
        nddTitle: 'Ajouté pour la livraison rapide',
        reserveTitle: `Ajouté pour le ramassage à ${vars[0]}`,
        autoReplenishTitle: 'Ajouté pour le réapprovisionnement automatique',
        proceedToBasket: 'Passer au panier',
        viewInBasket: 'Voir dans le panier',
        viewAndCheckout: 'Voir le panier et passer à la caisse',
        viewAndReserve: 'Voir le panier et réserver',
        testSeeDetails: 'Voir les détails',
        mostCommon: 'le plus courant',
        deliverEvery: 'Livrer chaque',
        weeksShort: 'semaines',
        monthsShort: 'mois',
        months: 'mois',
        weeks: 'semaines',
        urgencyMessage: 'IL N’EN RESTE QUE QUELQUES-UNS : PASSEZ BIENTÔT À LA CAISSE',
        viewBasket: 'Voir le panier',
        limitedStock: 'Quantités limitées',
        inStock: 'En stock',
        at: 'à',
        for: 'pour',
        checkout: 'Passer à la caisse',
        seeSamplesNote: '*Vous pouvez voir des échantillons, des récompenses et des promotions dans le panier',
        freeShippingAdd: 'Ajouter',
        freeShippingFor: 'pour',
        fastFreeShipping: 'Expédition GRATUITE',
        freeShippingShippingOr: 'RAPIDE ou',
        freeShippingOr: 'ou',
        freeShippingSignIn: 'Ouvrir une session',
        freeShippingNoMinSpend: 'pour profiter de l’expédition GRATUITE sans achat minimum',
        freeShippingOnAllOrders: 'pour profiter de l’expédition GRATUITE sur toutes les commandes',
        freeShippingThresholdMet: 'Vous profitez de',
        fastFreeShippingFull: 'l’expédition GRATUITE RAPIDE',
        freeShippingBeautyInsiderNoMinSpend: 'sans achat minimum, car vous êtes membre Beauty Insider.',
        freeShippingBeautyInsiderOnAllOrders: 'sur toutes les commandes, car vous êtes membre Beauty Insider.',
        freeShippingProgressAriaLabel: `Progression pour obtenir l’expédition gratuite : ${vars[0]} % pour ${vars[1]}`
    };

    return resources[label];
}
